import { useEffect, useState } from 'react';
import { logOut, selectCurrentToken, setCredentials } from '../features/authentication/authSlice';
import { useRefreshMutation } from '../features/authentication/authApiSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const token = useSelector(selectCurrentToken);
  const [refresh] = useRefreshMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        const authResponse = await refresh().unwrap();
        if (authResponse?.accessToken) {
          dispatch(setCredentials({ accessToken: authResponse.accessToken }));
        } else {
          dispatch(logOut());
        }
      } catch (err) {
        console.error('Refresh failed:', err);
        dispatch(logOut());
      } finally {
        setIsLoading(false);
      }
    };

    if (!token) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }
  }, [token, dispatch, refresh]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return <Outlet />;
};

export default PersistLogin;